import React, { FC } from 'react'
import { BasketType } from 'types/basket'
import { CautionCard, OrderCardList } from 'components/Card'
import { NoOrderSection } from 'components/Order'
import { OrderTime, OrderType } from 'types/checkout'
import { UserType } from 'types/user'

type Props = {
  baskets: BasketType[]
  isPast: boolean
  orders: OrderType[]
  orderTimes: OrderTime[]
  sortKey: 'checkout_at' | 'pickup_time'
  sortOrder: 'asc' | 'desc'
  storeBaskets: BasketType[]
  users: UserType[]
}

const OrderContainer: FC<Props> = (props) => {
  const { baskets, isPast, orders, orderTimes, sortKey, sortOrder, storeBaskets, users } = props
  // 受取番号が存在する場合
  if (storeBaskets.length > 0) {
    if (baskets.length > 0 && orders.length > 0) {
      return (
        <OrderCardList
          baskets={baskets}
          orders={orders}
          orderTimes={orderTimes}
          sortKey={sortKey}
          sortOrder={sortOrder}
          users={users}
        />
      )
    } else {
      return (
        <CautionCard
          align={'center'}
          caution={'条件に合う注文がありません'}
          description={'ほかの方法で検索してみてください'}
        />
      )
    }
  } else {
    return <NoOrderSection isPast={isPast} />
  }
}

export default OrderContainer
